import api from "./api";

const getAll = () => {
  return api.get("/api/service-type/get-all");
};

// Ungated selection list for WO create modal / service-type dropdown
// (picking a service type on a work order must not require service:read).
const getAllForSelection = () => {
  return api.get("/api/service-type/get-all-for-selection");
};

const save = (serviceType) => {
  return api.post("/api/service-type/save", serviceType);
};

const update = (serviceType) => {
  return api.post("/api/service-type/update", serviceType);
};

const archive = (serviceTypeId) => {
  return api.post("/api/service-type/archive", { serviceTypeId });
};

const restore = (serviceTypeId) => {
  return api.post("/api/service-type/restore", { serviceTypeId });
};

const ServiceTypeService = {
  getAll,
  getAllForSelection,
  save,
  update,
  archive,
  restore,
};

export default ServiceTypeService;
